function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M77.5646 45.2332C69.1601 32.3643 70.0535 19.1732 66.0023 12.971C61.9512 6.76876 49.8779 -3.92458 21.3512 14.7088C-7.17543 33.3421 0.080119 53.5976 4.5379 60.4176C25.4001 92.3554 92.4512 68.0243 77.5646 45.2332Z",
  fill: "#F7F7F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M65 41.6666V56.1111C65 58.5555 63 60.5555 60.5556 60.5555H19.4444C17 60.5555 15 58.5555 15 56.1111V41.6666H23.3556C24.3333 41.6666 25.2 42.3111 25.4667 43.2444L27.8667 51.2C28.1333 52.1333 29 52.7777 29.9778 52.7777H50.0222C51 52.7777 51.8667 52.1333 52.1333 51.2L54.5333 43.2444C54.8 42.3111 55.6667 41.6666 56.6444 41.6666H65Z",
  fill: "#F3F3F1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M65 41.6667H56.6444C55.6667 41.6667 54.8 42.3111 54.5333 43.2444L52.1333 51.2C51.8667 52.1333 51 52.7778 50.0222 52.7778H29.9778C29 52.7778 28.1333 52.1333 27.8667 51.2L25.4667 43.2444C25.2 42.3111 24.3333 41.6667 23.3556 41.6667H15L25 19.4444H55L65 41.6667Z",
  fill: "#E7F5FE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M57.1336 51.2L59.5336 43.2444C59.8002 42.3111 60.6669 41.6666 61.6447 41.6666H56.6447C55.6669 41.6666 54.8002 42.3111 54.5336 43.2444L52.1336 51.2C51.8669 52.1333 51.0002 52.7777 50.0225 52.7777H55.0225C56.0002 52.7777 56.8669 52.1333 57.1336 51.2Z",
  fill: "#D5DBE1"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20 56.1111V41.6666H15V56.1111C15 58.5555 17 60.5555 19.4444 60.5555H24.4444C22 60.5555 20 58.5555 20 56.1111Z",
  fill: "#D5DBE1"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M25 19.4444L15 41.6667H20L30 19.4444H25Z",
  fill: "#B6E2FB"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M32.8666 51.2L30.4666 43.2444C30.1999 42.3111 29.3332 41.6666 28.3555 41.6666H23.3555C24.3332 41.6666 25.1999 42.3111 25.4666 43.2444L27.8666 51.2C28.1332 52.1333 28.9999 52.7777 29.9777 52.7777H34.9777C33.9999 52.7777 33.1332 52.1333 32.8666 51.2Z",
  fill: "#B6E2FB"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M61.6536 14.4445C59.8159 14.4445 58.3203 12.9489 58.3203 11.1112C58.3203 9.27339 59.8159 7.77783 61.6536 7.77783C63.4914 7.77783 64.987 9.27339 64.987 11.1112C64.987 12.9489 63.4914 14.4445 61.6536 14.4445ZM61.6536 10.0001C61.0403 10.0001 60.5425 10.5001 60.5425 11.1112C60.5425 11.7223 61.0403 12.2223 61.6536 12.2223C62.267 12.2223 62.7648 11.7223 62.7648 11.1112C62.7648 10.5001 62.267 10.0001 61.6536 10.0001Z",
  fill: "#75768A"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6514 10.7103L17.2227 9.13892L20.3654 12.2816L18.7941 13.853L15.6514 10.7103Z",
  fill: "#75768A"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2554 21.3181L18.3981 18.1754L19.9694 19.7467L16.8267 22.8894L15.2554 21.3181Z",
  fill: "#75768A"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2925 12.2825L27.4352 9.13977L29.0065 10.7111L25.8638 13.8538L24.2925 12.2825Z",
  fill: "#75768A"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M60.5557 62.2222H19.4446C16.0735 62.2222 13.3335 59.4822 13.3335 56.111V41.6666C13.3335 41.431 13.3824 41.1977 13.4802 40.9822L23.4802 18.7599C23.7491 18.1622 24.3446 17.7777 25.0002 17.7777H55.0002C55.6557 17.7777 56.2513 18.1622 56.5202 18.7599L66.5202 40.9822C66.6179 41.1977 66.6668 41.431 66.6668 41.6666V56.111C66.6668 59.4822 63.9268 62.2222 60.5557 62.2222ZM16.6668 42.0244V56.111C16.6668 57.6422 17.9135 58.8888 19.4446 58.8888H60.5557C62.0868 58.8888 63.3335 57.6422 63.3335 56.111V42.0244L53.9224 21.111H26.0779L16.6668 42.0244Z",
  fill: "#75768A"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M50.0133 54.4444H29.9867C28.2578 54.4444 26.76 53.3311 26.2622 51.6733L23.8778 43.7311C23.8067 43.4978 23.5889 43.3333 23.3467 43.3333H15V40H23.3467C25.0756 40 26.5733 41.1133 27.0711 42.7711L29.4556 50.7133C29.5267 50.9489 29.7444 51.1111 29.9867 51.1111H50.0133C50.2556 51.1111 50.4756 50.9489 50.5444 50.7133L52.9289 42.7711C53.4267 41.1133 54.9222 40 56.6533 40H65V43.3333H56.6533C56.4111 43.3333 56.1911 43.4956 56.1222 43.7311L53.7378 51.6733C53.24 53.3311 51.7422 54.4444 50.0133 54.4444Z",
  fill: "#75768A"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M4.44434 58.8888H75.5554V62.2221H4.44434V58.8888Z",
  fill: "#75768A"
});

function SvgSchedulingEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulingEmpty);
export default __webpack_public_path__ + "static/media/scheduling-empty.498fd087.svg";
export { ForwardRef as ReactComponent };